export const containerClassName = `
   flex flex-col justify-between items-center  gap-6
   w-full p-[32px_20px_16px_24px]
`

export const imageClassName = 'w-[194px] cursor-pointer'

export const searchClassName = 'text-md-regular flex-1 text-start'

export const shortcutContainerClassName = `
   text-xs-regular py-[2px] px-[4px]
   border
   rounded-[4px]
`

export const searchButtonContainerStyles = `
   w-full
   rounded-[10px]
   border-0
   shadow-none
`
